// account
export const ACCOUNT_SET = 'accountSet';

// dashboard
export const DASHBOARDS_FETCHED = 'dashboardsFetched';
export const DASHBOARD_FETCHED = 'dashboardFetched';
export const DASHBOARD_CREATED = 'dashboardCreated';
export const DASHBOARD_UPDATED = 'dashboardUpdated';
export const DASHBOARD_DELETED = 'dashboardDeleted';
export const DASHBOARD_SCOPE_SET = 'dashboardScopeSet';
export const DASHBOARD_TIME_SET = 'dashboardTimeSet';
export const DASHBOARD_SLICER_SET = 'dashboardSlicerSet';
export const DASHBOARD_SLICER_CLEAR_VALUES = 'dashboardSlicerClearValues';
export const DASHBOARD_REFRESH = 'dashboardRefresh';

// monitors
export const MONITORS_FETCHED = 'monitorsFetched';
export const MONITOR_TRIGGER_CREATED = 'monitorTriggerCreated';
export const MONITOR_KPI_CREATED = 'monitorKpiCreated';
export const MONITOR_KPI_DELTA_CREATED = 'monitorKpiDeltaCreated';
export const MONITOR_TRIGGER_UPDATED = 'monitorTriggerUpdated';
export const MONITOR_KPI_UPDATED = 'monitorKpiUpdated';
export const MONITOR_KPI_DELTA_UPDATED = 'monitorKpiDeltaUpdated';
export const MONITOR_ENABLED = 'monitorEnabled';
export const MONITOR_DISABLED = 'monitorDisabled';
export const MONITOR_DELETED = 'monitorDeleted';

// filters
export const FILTERS_FETCHED = 'filtersFetched';
export const FILTER_CREATED = 'filterCreated';
export const FILTER_UPDATED = 'filterUpdated';
export const FILTER_DELETED = 'filterDeleted';

// role
export const ACCOUNTS_FETCHED = 'accountsFetched';
export const ACCOUNT_ADDED = 'accountAdded';
export const LEGACY_TOKEN_FETCHED = 'legacyTokenFetched';
export const ACCOUNT_SELECTED = 'accountSelected';
export const ACCOUNT_RESTORED = 'accountRestored';

// persistence
export const PERSISTENCE_ACCOUNT_SET = 'persistenceAccountSet';
export const PERSISTENCE_SET = 'persistenceSet';

// settings
export const SETTINGS_FETCHED = 'settingsFetched';
export const ACCOUNT_SETTINGS_FETCHED = 'accountSettingsFetched';
export const USER_SETTINGS_FETCHED = 'userSettingsFetched';

// ui
export const FULLSCREEN_SET = 'fullscreenSet';
export const SUBNAV_CHANGED = 'subnavChanged';
export const MINIMISE_NAVIGATION = 'minimiseNavigation';
export const UI_METADATA_FETCHED = 'uiMetadataFetched';

// user
export const USER_FETCHED = 'userFetched';
export const USER_ACCOUNTS_FETCHED = 'userAccountsFetched';
export const SET_TEMPORARY_EMAIL = 'setTemporaryEmail';

// users
export const USERS_FETCHED = 'usersFetched';
export const USER_REVOKED = 'userRevoked';
export const INVITES_FETCHED = 'invitesFetched';
export const USER_ROLE_UPDATED = 'userRoleUpdated';
export const INVITE_REVOKED = 'inviteRevoked';

// widgets
export const WIDGETS_FETCHED = 'widgetsFetched';

// view
export const VIEW_KPI_SELECTED = 'VIEW_KPI_SELECTED';
export const VIEW_KPI_LEGEND_TOGGLED = 'VIEW_KPI_LEGEND_TOGGLED';
export const VIEW_SHOW_ZERO_VALUES_CHANGED = 'VIEW_SHOW_ZERO_VALUES_CHANGED';
export const VIEW_SHOW_MAX_VALUES_CHANGED = 'VIEW_SHOW_MAX_VALUES_CHANGED';
export const VIEW_PIVOT_PROPERTY_CHANGED = 'VIEW_PIVOT_PROPERTY_CHANGED';
export const VIEW_FILTER_CHANGED = 'VIEW_FILTER_CHANGED';
export const VIEW_PANE_SELECTED = 'VIEW_PANE_SELECTED';
export const VIEW_PANE_DESELECTED = 'VIEW_PANE_DESELECTED';
export const VIEW_SELECTED_DEVICES_CHANGED = 'VIEW_SELECTED_DEVICES_CHANGED';
export const VIEW_TIME_PERIOD_CHANGED = 'VIEW_TIME_PERIOD_CHANGED';
export const VIEW_TIME_RANGE_CHANGED = 'VIEW_TIME_RANGE_CHANGED';
export const VIEW_CURRENT_TIME_UPDATE = 'VIEW_CURRENT_TIME_UPDATE';
export const VIEW_INITIALISED = 'VIEW_INITIALISED';
export const VIEW_REFRESH_TIME_CHANGED = 'VIEW_REFRESH_TIME_CHANGED';
export const VIEW_DATA_PERIOD_CHANGED = 'VIEW_DATA_PERIOD_CHANGED';
export const VIEW_UPDATE_NOW_TIME = 'VIEW_UPDATE_NOW_TIME';
export const VIEW_SET_PIVOT_PROPERTY = 'viewSetPivotProperty';
export const VIEW_CHANGE_MODEL = 'viewChangeModel';

// Devices
export const SELECTED_DEVICES_CHANGED = 'selectedDevicesChanged';

// KPIs
export const KPIS_UPDATED = 'KPIS_UPDATED';
export const KPI_UPDATED = 'KPI_UPDATED';
export const KPI_DELETED = 'KPI_DELETED';

// Integrations
export const INTEGRATIONS_FETCHED = 'integrationsFetched';
export const WEBHOOK_CREATED = 'webhookCreated';
export const WEBHOOK_UPDATED = 'webhookUpdated';
export const WEBHOOK_REMOVED = 'webhookRemoved';
